import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import useTemporaryResevation from '../../hooks/useTemporaryResevation';
import CleanupLayout from '../Cleanup/CleanupLayout';
// Page text color: CleanupLayout applies viewRootTextPrimarySx (util/chartTheme).
import TemporaryReservationDayContent from './TemporaryReservationDayContent';

export default function TemporaryReservationCleanup() {
  const {
    getTemporaryReservationsByEntertainmentAndDate,
    invalidateTemporaryReservation,
  } = useTemporaryResevation();

  const [reservations, setReservations] = useState([]);
  const [isLoadingReservations, setIsLoadingReservations] = useState(false);
  const [reservationActionState, setReservationActionState] = useState({});

  const loadReservations = useCallback(
    async ({ entertainmentId, date }) => {
      if (!entertainmentId || !date) {
        setReservations([]);
        return;
      }
      setReservations([]);
      setIsLoadingReservations(true);
      try {
        const response = await getTemporaryReservationsByEntertainmentAndDate(
          entertainmentId,
          date
        );
        setReservations(response?.reservations || []);
      } catch (error) {
        setReservations([]);
        toast.error('Fehler beim Laden der Reservierungen.');
      } finally {
        setIsLoadingReservations(false);
      }
    },
    [getTemporaryReservationsByEntertainmentAndDate]
  );

  const handleInvalidateReservation = useCallback(
    async (reservationId, selection) => {
      if (!reservationId) return;
      setReservationActionState(prev => ({ ...prev, [reservationId]: true }));
      try {
        await invalidateTemporaryReservation(reservationId);
        toast.success('Reservierung wurde ungültig gemacht.');
        await loadReservations(selection);
      } catch (error) {
        toast.error('Fehler beim Ungültigmachen der Reservierung.');
      } finally {
        setReservationActionState(prev => {
          const next = { ...prev };
          delete next[reservationId];
          return next;
        });
      }
    },
    [invalidateTemporaryReservation, loadReservations]
  );

  const renderDayContent = useCallback(
    () => (
      <TemporaryReservationDayContent
        reservations={reservations}
        reservationActionState={reservationActionState}
        onInvalidate={handleInvalidateReservation}
        fetchReservations={loadReservations}
      />
    ),
    [
      reservations,
      reservationActionState,
      handleInvalidateReservation,
      loadReservations,
    ]
  );

  return (
    <CleanupLayout
      requiredRight='temporaryReservation:special:clear'
      renderDayContent={renderDayContent}
    />
  );
}
